
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;

        let url = '';

        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }

        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }

        return url + relativeUrl;
      }
import { CorsWorker as Worker } from './CorsWorker';
var worker;
export function getWorker() {
    if (worker) {
        return Promise.resolve(worker);
    }
    if (IS_WEBPACK5) {
        var wrapperWorker = new Worker(new URL('@office-start/edgeworth-worker', ({ url: getAbsoluteUrl('les/@office-start/edgeworth-trie-service/dist/getWorker.js') }).url));
        worker = Promise.resolve(wrapperWorker.getWorker());
        return worker;
    }
    else {
        return import(
        /* webpackChunkName: "edgeworth-worker" */ '@office-start/edgeworth-worker').then(function (mod) {
            worker = new mod.default();
            return worker;
        });
    }
}
//# sourceMappingURL=getWorker.js.map